import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { parseInlineStyle } from '../../../modules/utils'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'

interface BtnPreset {
  weight: string
  size: string
  height: string
  color: string
  padding: string
  display: string
  alignItems?: string
}

const btnPresets: Record<string, BtnPreset> = {
  searchAll: {
    weight: '500',
    size: '14px',
    height: '16.8px',
    color: '#1E007D',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
  },
}

export class LvcSimpleButton extends MinzeElement {
  attrs: Attrs = [
    'inner-style',
    'color',
    'font-weight',
    'data-group-id',
    'data-value',
    'on-click',
    'text-decoration',
  ]

  async onButtonClick(event: any): Promise<void> {
    Callback.call(this.onClick as string, this.dataValue ?? '')
    //let searchBarSubscriber = new SearchBarSubscriber((this.dataGroupId ?? "") as string);
    // await MainModule.getInstance().getSearchManager().subscribe(searchBarSubscriber);
    // await searchBarSubscriber.doSearch(decodeURIComponent((this.dataValue ?? "") as string));
  }

  get btnPreset(): BtnPreset | undefined {
    const preset = this.getAttribute('btn-preset')
    return preset ? btnPresets[preset as keyof typeof btnPresets] : undefined
  }

  static observedAttributes = ['inner-style']
  html = () => `
    <div class="button" data-value="${this.dataValue}">
      <slot></slot>
    </div>
  `

  css = () => {
    return `
      :host {
        font-family: ${Font.family};  
      }
      
      .button {
        cursor: pointer;
        color: ${this.btnPreset?.color ?? ''};
        font-weight: ${this.btnPreset?.weight ?? ''};
        font-size: ${this.btnPreset?.size ?? ''};
        line-height: ${this.btnPreset?.height ?? ''};
        padding: ${this.btnPreset?.padding ?? ''};
        align-items: ${this.btnPreset?.alignItems ?? ''};
        display: ${this.btnPreset?.display ?? ''};
        text-decoration: ${this.textDecoration ?? ''};
      }


      ${parseInlineStyle(this.innerStyle as string)}
    `
  }

  eventListeners: EventListeners = [[this, 'click', this.onButtonClick.bind(this)]]
}
